<template>
    <div class="col-sm-6 col-md-6">
        <h2>{{ title_legalnotices[getCurrentLocale] }}</h2>
        <ul class="discover triangle hover row">
            <li class="col-xs-6">
                <a href="#" v-on:click.prevent="call_getwebcomponent('AGB')">{{ listpoint_agb[getCurrentLocale] }}</a>
            </li>
            <!-- <li class="col-xs-6">
                <a href="#" v-on:click.prevent="call_getwebcomponent('ABB')">{{ listpoint_abb[getCurrentLocale] }}</a>
            </li> -->
            <li class="col-xs-6">
                <a href="#" v-on:click.prevent="call_getwebcomponent('IMPRINT')">{{ listpoint_impressum[getCurrentLocale] }}</a>
            </li>
            <li class="col-xs-6">
                <!-- <a href="/infos-privacy-policy/#/privacy-policy" v-bind:class="{ active: getPathName('infos-privacy-policy') }">{{ infosprivacypolicy[getCurrentLocale] }}</a> -->
                <a href="#" v-on:click.prevent="call_getwebcomponent('PCPE')">{{ infosprivacypolicy[getCurrentLocale] }}</a>
            </li>
        </ul>



        <!-- <br />
        <h2>{{ title_career[getCurrentLocale] }}</h2>
        <p>
            <a href="/career/" v-bind:class="{ active: getPathName('career') }">{{ careertext[getCurrentLocale] }}</a>
        </p>



        <br />
        <h2>{{ title_press[getCurrentLocale] }}</h2>
        <p>
            <a href="/pressreleases/">15.06.2020 - SUNDAIR startet ab Juli wieder zu den...</a><br />
            <a href="/pressreleases/">21.02.2020 - schauinsland-reisen und SUNDAIR präsent...</a><br />
            <a href="/pressreleases/">18.11.2019 - Nonstop nach Korfu: SUNDAIR erweitert...</a><br />
            <a href="/pressreleases/">06.09.2019 - SUNDAIR  mit Zusatzprogramm ab Düssel...</a><br />
            <a href="/pressreleases/">23.08.2019 - Mehr Urlaubsflüge und neue Strecken...</a><br />
            <a href="/pressreleases/">15.08.2019 - SUNDAIR präsentiert Sommerziele 2020...</a><br />
            <a href="/pressreleases/">...</a>
        </p> -->










        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal name="size-modal"
                transition="nice-modal-fade"
                classes="demo-modal-class"
                :min-width="200"
                :min-height="200"
                :pivot-y="0.5"
                :adaptive="true"
                :scrollable="true"
                :reset="true"
                height="auto"
                @before-open="beforeOpen"
                @opened="opened"
                @closed="closed"
                @before-close="beforeClose">
                <div class="size-modal-content">
                    <h2>{{ webcomponenttype }}</h2>
                    <span v-if="sections.length > 1">
                        <div class="toggle-container box" id="accordion1" v-for="(section, index) in sections" :key="index" style="margin-bottom:0px;">
                            <div class="panel style1">
                                <h4 class="panel-title">
                                    <a class="collapsed" v-bind:href="'#acc1_' + index" data-toggle="collapse" data-parent="#accordion1">{{ section.title }}</a>
                                </h4>
                                <div class="panel-collapse collapse" v-bind:id="'acc1_' + index">
                                    <div class="panel-content">
                                        <span v-html="section.content"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </span>

                    <span v-if="sections.length === 1">
                        <div class="panel style1">
                            <span v-html="sections[0].content"></span>
                        </div>
                    </span>
                </div>
        </modal>
    </div>
</template>

<script>
    import axios from 'axios';
    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                listpoint_agb: {
                    en: 'General Terms',
                    de: 'AGB',
                },
                listpoint_abb: {
                    en: 'Terms and Conditions',
                    de: 'ABB',
                },
                listpoint_impressum: {
                    en: 'Imprint',
                    de: 'Impressum',
                },
                listpoint_sec: {
                    en: 'Data Protection & Privacy',
                    de: 'Datenschutz',
                },
                infosprivacypolicy: {
                    en: 'Data Protection & Privacy',
                    de: 'Datenschutz',
                },
                title_legalnotices: {
                    en: 'Legal Notices',
                    de: 'Rechtliche Hinweise',
                },
                title_career: {
                    en: 'Career',
                    de: 'Karriere',
                },
                careertext: {
                    en: 'Learn more about open positions at SUNDAIR. Become a part of our team as well.',
                    de: 'Mehr über offene Positionen bei SUNDAIR erfahren. Werden Sie auch ein Teil unseres Teams.',
                },
                title_press: {
                    en: 'Press',
                    de: 'Presse',
                },
                listpoint_faq : {
                    en: 'Faq',
                    de: 'Faq',
                },
                // currentLocale: 'de',
                // >>> -------------------------- Modal
                webcomponenttype: '', // ABB/FAQ aso.
                sections: [], // data
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /*******************************************************************
            * Call::'/site/getwebcomponent/'
            *
            * Desc:
            * Note:
            *
            * @param {string} comptype (kind of Component)
            * @param
            * @return
            */
            call_getwebcomponent: function (comptype) {

                var me = this,
                    hdrs = '';


                me.$toc('>>> shared/footer/SecondRow.vue >>> call_getwebcomponent');
                // >>> 1. Builds Object ----------------------------------------
                const requestParamObject = {
                    name: comptype
                };


                // >>> #267, Translation ---------------------------------------
                if (comptype === 'ABB') {
                    this.webcomponenttype = this.listpoint_abb[this.getCurrentLocale];
                }  else if (comptype === 'AGB') {
                    this.webcomponenttype = this.listpoint_agb[this.getCurrentLocale];
                }  else if (comptype === 'IMPRINT') {
                    this.webcomponenttype = this.listpoint_impressum[this.getCurrentLocale];
                }  else if (comptype === 'PCPE') {
                    this.webcomponenttype = this.listpoint_sec[this.getCurrentLocale];
                }  else if (comptype === 'FAQ') {
                    this.webcomponenttype = this.listpoint_faq[this.getCurrentLocale];
                } else {
                    this.webcomponenttype = comptype; // remember
                }


                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put('/site/getwebcomponent/', requestParamObject)
                    .then(function(response) { // 'OK'
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.$modal.show('size-modal', { data: response.data });
                                me.$vp_um();
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eof call_getwebcomponent()





            /******************************************************************* 'Utilities - Common'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * getPathName()
            *
            * Desc:
            * Note:
            *
            * @param {string} pathname ()
            * @param
            * @return
            */
            getPathName: function (pathname) {

                var me = this,
                    currentUrl = window.location.pathname,
                    currentUrl = currentUrl.slice(1,-1);


                // me.$toc('>>> shared/footer/LanguageList.vue >>> getPathName');
                if (pathname === currentUrl) {
                    return true;
                } else {
                    return false;
                }

            }, // eof getPathName()





            /*******************************************************************
            * Modals:
            *******************************************************************/
            /*******************************************************************
            * Modal - Events - beforeOpen
            *
            * Desc:
            * Note: Catches 'data' Object from $modal.show.
            *
            */
            beforeOpen (event) {

                this.sections = event.params.data.sections;

            }, // eof beforeOpen()

            /*******************************************************************
            * Modal - Events - beforeClose
            *
            * Desc:
            * Note:
            *
            */
            beforeClose () {

                this.sections = [];

            }, // eof beforeClose()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    /* Modal */
    .size-modal-content {
        padding: 10px;
        font-style: 13px;
        background-color: rgb(255, 255, 255);
        padding-right: 50px;
    }
    .v--modal-overlay[data-modal="size-modal"] {
        background: rgba(0, 0, 0, 0.5);
        z-index: 555555 !important;

    }
    .demo-modal-class {
        border-radius: 5px;
        background: #F7F7F7;
        box-shadow: 5px 5px 30px 0px rgba(46,61,73, 0.6);
    }
</style>


// WEBPACK FOOTER //
// src/components/shared/footer/SecondRow.vue